import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../services/supabase'

const DEFAULTS = {
  feature_tasks:        'false',
  feature_claims_tasks: 'false',
}

export function useAppSettings() {
  const [settings, setSettings] = useState(DEFAULTS)
  const [loading, setLoading]   = useState(true)

  const load = useCallback(async () => {
    const { data } = await supabase.from('app_settings').select('key, value')
    if (data) {
      const map = { ...DEFAULTS }
      data.forEach(row => { map[row.key] = row.value })
      setSettings(map)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    load()

    // Realtime: when admin changes a setting all users' sidebars update immediately
    const channel = supabase
      .channel('app_settings_realtime')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'app_settings' }, load)
      .subscribe()

    return () => { supabase.removeChannel(channel) }
  }, [load])

  const updateSetting = async (key, value) => {
    const { error } = await supabase
      .from('app_settings')
      .upsert({ key, value, updated_at: new Date().toISOString() })
    if (!error) setSettings(prev => ({ ...prev, [key]: value }))
    return !error
  }

  return {
    settings,
    loading,
    isEnabled: (key) => settings[key] === 'true',
    updateSetting,
  }
}
